/** The remaining player's word on an empty side: a passerby or an ex-member. Mirrors the API's StandInVerdict. */
export enum StandInVerdict {
  UNIQUE = 'unique',
  NOT_UNIQUE = 'not_unique',
}
